import * as constants from '../constants';
import { createSampleRow, deleteSampleRow } from '../actions';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.deleteSampleRow.success: {
            return action.payload;
        }

        case constants.deleteSampleRow.error: {
            return { isLoading: false };
        }

        case constants.deleteSampleRow.try: {
            return { isLoading: true };
        }

        default:
            return state;
    }
}